import React, { Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Hero from './components/Hero';
import HomeAbout from './components/HomeAbout';
import About from './components/About';
import Services from './components/Services';
import ServicesPage from './components/ServicesPage';
import Stats from './components/Stats';
import Associations from './components/Associations';
import Testimonials from './components/Testimonials';
import TelehealthServiceDetail from './components/TelehealthServiceDetail';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SEO from './components/SEO';
import './App.css';
import './mobile-enhancements.css';
import './mobile-specific.css';
import { disableMobileAnimations } from './utils/mobileUtils';
import { DEFAULT_SEO_DESCRIPTION, DEFAULT_SEO_KEYWORDS, SITE_URL } from './siteConfig';

const LoadingFallback = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '200px',
      fontSize: '18px',
      color: '#666',
    }}
  >
    Loading...
  </div>
);

function App() {
  useEffect(() => {
    disableMobileAnimations();
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Header />
          <main>
            <Suspense fallback={<LoadingFallback />}>
              <Routes>
                <Route
                  path="/"
                  element={
                    <>
                      <SEO
                        title="Home"
                        description={DEFAULT_SEO_DESCRIPTION}
                        keywords={DEFAULT_SEO_KEYWORDS}
                        canonicalUrl={`${SITE_URL}/`}
                      />
                      <Hero />
                      <HomeAbout />
                      <Services />
                      <Stats />
                      <Associations />
                      <Testimonials />
                    </>
                  }
                />
                <Route
                  path="/about"
                  element={
                    <>
                      <SEO
                        title="About Us"
                        description="Learn about Open Arms Healthcare Services LLC—our mission to make safe, fast, affordable telehealth available on your schedule, and our transparent pricing."
                        keywords="about Open Arms Healthcare, telehealth mission, affordable virtual care"
                        canonicalUrl={`${SITE_URL}/about`}
                      />
                      <About />
                    </>
                  }
                />
                <Route
                  path="/services"
                  element={
                    <>
                      <SEO
                        title="Our Services"
                        description="Telehealth services including sick visits, medication refills, lab orders with interpretation, weight loss, chronic care, and smoking cessation—with clear per-visit pricing."
                        keywords="telehealth services, virtual sick visit, medication refill online, lab order telehealth, chronic care virtual"
                        canonicalUrl={`${SITE_URL}/services`}
                      />
                      <ServicesPage />
                    </>
                  }
                />
                <Route path="/services/:slug" element={<TelehealthServiceDetail />} />
                <Route path="/careers" element={<Navigate to="/contact" replace />} />
                <Route path="/founder" element={<Navigate to="/about" replace />} />
                <Route
                  path="/contact"
                  element={
                    <>
                      <SEO
                        title="Contact Us"
                        description="Contact Open Arms Healthcare Services LLC by call, email, or text to schedule telehealth care or ask about our services and pricing."
                        keywords="contact telehealth, Open Arms Healthcare contact, schedule virtual visit"
                        canonicalUrl={`${SITE_URL}/contact`}
                      />
                      <Contact />
                    </>
                  }
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
